import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { TabsPage } from '../pages/tabs/tabs';
import { LotenPage } from '../pages/loten/loten';
import { VerkopenPage } from '../pages/verkopen/verkopen';
import { QrscannerPage } from '../pages/qrscanner/qrscanner';
import { StatusPage } from '../pages/status/status';
import { LotDetailPage } from '../pages/lot-detail/lot-detail';
import { StatusDetailPage } from '../pages/status-detail/status-detail';
import { LoginPage } from '../pages/login/login';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpClientModule } from '@angular/common/http';

import { QrHelperProvider } from '../providers/qr-helper/qr-helper';
import { UploadHelperProvider } from '../providers/upload-helper/upload-helper';
import { RestProvider } from '../providers/rest/rest';
import { ToastHelperProvider } from '../providers/toast-helper/toast-helper';
import { AuthProvider } from '../providers/auth/auth';
@NgModule({
  declarations: [
    MyApp,
    TabsPage,
    LotenPage,
    VerkopenPage,
    QrscannerPage,
    StatusPage,
    LotDetailPage,
    StatusDetailPage,
    LoginPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: 'Terug'
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    TabsPage,
    LotenPage,
    VerkopenPage,
    QrscannerPage,
    StatusPage,
    LotDetailPage,
    StatusDetailPage,
    LoginPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    RestProvider,
    QrHelperProvider,
    UploadHelperProvider,
    ToastHelperProvider,
    AuthProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts